import { render, staticRenderFns } from "./appMainSwitch.vue?vue&type=template&id=78479b81&scoped=true"
import script from "./appMainSwitch.vue?vue&type=script&lang=js"
export * from "./appMainSwitch.vue?vue&type=script&lang=js"
import style0 from "./appMainSwitch.vue?vue&type=style&index=0&id=78479b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78479b81",
  null
  
)

export default component.exports